/*jslint white: true, nomen: true */
/*global angular, $ */
(function() {
  'use strict';
  angular.module('app.common')

    .controller('regionPhoneNumber', ['$scope', '$rootScope','$timeout', 'regionStorageFactory','$window', 'campaignPhoneOverride', function($scope, $rootScope, $timeout, regionStorageFactory, $window, campaignPhoneOverride) {
      $timeout(function() {

        var campaignPhone = campaignPhoneOverride.getOverridePhoneForCurrentRegion();
        if (campaignPhone) { $scope.region_phone = campaignPhone; return; }

        const firstSegment = $window.location.pathname.split('/')[1];
        $scope.region_phone = firstSegment == 'find-new-homes' && regionStorageFactory.getRegionPhone() ? regionStorageFactory.getRegionPhone() : "1-855-342-2281";

        var unbind = $rootScope.$on('selectedRegion', function(event, region) {
          $scope.region_phone = campaignPhoneOverride.getOverridePhoneForCurrentRegion() || regionStorageFactory.getRegionPhone() || '1-855-342-2281';
        });

        $scope.$on('$destroy', unbind);
      }, 200);  

    }])

    .controller('modalCtrl', ['$scope','$rootScope', '$uibModal', 'DeviceService',
    function($scope,$rootScope, $uibModal, DeviceService) {
      const params = new URLSearchParams(window.location.search);
      
      const modalConfigs = {
        'schedule-tour': {
          templateUrl: '/components/modal-schedule-a-tour.tpl.html',
          controller: 'modalInstance',
          size: 'md',
        },
        'join-list': {
          templateUrl: '/components/modal-become-a-vip',
          controller: 'modalInstance',
          size: 'sm',
        },
      };

      $rootScope.$on('contextDataLoaded', (event, contextData) => {
        $scope.specialistTours = contextData.specialistTours || false;
        
        if ($rootScope.triggerModalOpen) return;
        Object.keys(modalConfigs).forEach((paramKey) => {


          if (params.get(paramKey) === 'true') {

            const config = modalConfigs[paramKey];

            $scope.open(
              config.templateUrl,
              config.size,
              null,
              '',
              contextData || {}
            );

            $rootScope.$broadcast('modalOpen');
            $rootScope.triggerModalOpen = true;
          }
        });
      });
      $scope.open = function($elem, $size, iframe, windowClass = '', contextData = {}) {

        if(iframe && DeviceService.check() === 'phone'){
          //for ios, user must trigger a new tab
          window.open(iframe,'_blank');
        }else{
          var uibModalInstance = $uibModal.open({
            templateUrl: $elem,
            controller: 'modalInstance',
            animation: true,
            scope: $scope,
            size: $size,
            appendTo: $('.modal-container'),
            windowClass: windowClass,
            resolve: {
              contextData: function() {
                return contextData || {};
              }
            }
          });

          $rootScope.$broadcast('modalOpen');

          uibModalInstance.result.then(null, function () {
            $rootScope.$broadcast('modalClose');
            $rootScope.triggerModalOpen = false;
          });
        }

      };

      $scope.$on('triggerModal', function(event, args){
        $scope.open('/components/' + args.path,'compact');
      });

      $scope.prevDef = function(e){
        e.preventDefault();
      };
    }])
    .controller('modalInstance', [
      '$scope',
      '$uibModalInstance',
      '$timeout',
      'CommunitiesListDataService',
      'regionStorageFactory',
      '$window',
      'contextData',
    function(
      $scope,
      $uibModalInstance,
      $timeout,
      CommunitiesListDataService,
      regionStorageFactory,
      $window,
      contextData) {

      //cancel modal
      $scope.cancel = function() {
        $uibModalInstance.dismiss('cancel');
      };

      $scope.analyticsConfig = {
        googleAnalytics: {
          pageViewUrl: '/ajax-goals/qsu-footer-mobile'
        }
      };

      if(contextData.hasOwnProperty('type') && contextData.type === 'tour') {
        $scope.specialistTour = true;
        $scope.specialistTours = contextData.specialistTours || false;
        
        if(contextData.hasOwnProperty('community')){
          var community = contextData.community || {};
          $scope.contextLabel = 'new homes in ';
          $scope.contextLabel += community.name || 'this community';
          if (Array.isArray(community.model_homes)) {
            community.model_homes.forEach(function(modelHome) {
              if (modelHome.utour_url) {
                $scope.utour = true;
                $scope.utour_url = modelHome.utour_url;
              }
            });
          }
          if (community.assets && community.assets[0] && community.assets[0].image) {
            $scope.tourImage = community.assets[0].image.medium;
          }
        }
        if(contextData.hasOwnProperty('home')){
          var home = contextData.home || {};
          $scope.utour = home.utour_url ? true : false;
          $scope.utour_url = home.utour_url || '';
          var plan = home.plan || {};
          $scope.contextLabel = `the ${plan.name}` || 'this home';
          $scope.tourLocation = {
            address: home.address ? home.address : '',
            city: home.city ? home.city : '',
            state: home.state ? home.state : '',
            zip: home.zip ? home.zip : '',
          }

          if(home.assets && home.assets[0] && home.assets[0].image) {
            $scope.tourImage = home.assets[0].image.medium;
          } else if (home.images && home.images[0] && home.images[0].image){
            $scope.tourImage = home.images[0].image.medium;
          }
        }
        $scope.toggleTourType = function () {
          $scope.specialistTour = !$scope.specialistTour;
        };
      } 

      $timeout(() => {
        const $slick = jQuery('#slick-modal');
        if (!$slick.length) return;

        let currentPz = null;

        const destroyPanzoom = () => {
          if (currentPz) {
            currentPz.destroy();
            currentPz = null;
          }
        };

        const initPanzoomForSlide = (slick) => {
          destroyPanzoom();

          const $currentSlide = jQuery(slick.$slides.get(slick.currentSlide));
          const img = $currentSlide.find('img')[0];
          if (!img) return;

          const pz = Panzoom(img, { maxScale: 4, contain: false });
          const wrapper = img.closest('.image');
          wrapper.addEventListener('wheel', pz.zoomWithWheel, { passive: false });
          img.panzoomInstance = pz;
          currentPz = pz;
        };

        $slick.on('init reInit afterChange', function (event, slick) {
          initPanzoomForSlide(slick);
        });

        if ($slick.hasClass('slick-initialized')) {
          const slick = $slick.slick('getSlick');
          initPanzoomForSlide(slick);
        }

        var zoomInButton = document.getElementById('zoomIn');
        var zoomOutButton = document.getElementById('zoomOut');
        var resetButton = document.getElementById('reset');

        if (zoomInButton) {
          zoomInButton.onclick = function() {
            if (currentPz) currentPz.zoomIn();
          };
        }

        if (zoomOutButton) {
          zoomOutButton.onclick = function() {
            if (currentPz) currentPz.zoomOut();
          };
        }

        if (resetButton) {
          resetButton.onclick = function() {
            if (currentPz) currentPz.reset();
          };
        }

      }, 300);
    }])
    .controller('scheduleTourModalCtrl', ['$scope', function($scope){
      $scope.specialistTour = true;
    }]);
}());
